import React from 'react';
import { motion } from 'framer-motion';
export function ShowroomSection() {
  return <section className="w-full bg-white" data-id="element-74" data-mp="31kd5udvh4a16">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24" data-id="element-75" data-mp="31lfx4mwpkehm">
        <motion.div initial={{
        opacity: 0,
        x: -24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6
      }} className="overflow-hidden rounded-2xl" data-id="element-76" data-mp="3bi12588q9plg">
          <img src="https://cdn.magicpatterns.com/uploads/oNbWvwu1ygFd9kvzsBRwi9/Atlantic-Green-Full-2.png" alt="Full green stone slab on display inside the Granite & Marble Works indoor stone gallery" className="h-full w-full object-cover" data-id="element-77" data-mp="2zv58koaebtg" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 24
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6
      }} data-id="element-78" data-mp="335he117yf9l7">
          <h2 className="font-display text-3xl text-brand-charcoal sm:text-4xl" data-id="element-79" data-mp="3gx5n0vmwphxy">
            Experience Our Showroom
          </h2>
          <p className="mt-5 text-base leading-relaxed text-gray-600" data-id="element-80" data-mp="3lvgwh59ahqfn">
            Visit our 45,000 sq ft indoor stone gallery in the Capital Region.
          </p>
          <p className="mt-4 text-base leading-relaxed text-gray-600" data-id="element-81" data-mp="3vtwpxevshbsb">
            Our showroom has over 2,500 slabs of carefully selected stone in stock, including a
            variety of granite colors.
          </p>
          <a href="#get-started" className="mt-8 inline-flex items-center justify-center rounded-md bg-brand-teal px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-brand-tealDark" data-id="element-82" data-mp="21hgmsmyaidro">
            Schedule Your Showroom Tour
          </a>
        </motion.div>
      </div>
    </section>;
}